import React from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../i18n/LanguageContext";

// Catches render errors anywhere below it and shows a friendly fallback
// instead of a blank white screen.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught an error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <LanguageContext.Consumer>
          {({ t }) => (
            <div className="h-screen bg-gray-200 flex flex-col justify-center items-center px-6 text-center">
              <h1 className="text-2xl font-bold text-gray-700 mb-4">
                {t("errorBoundary.title")}
              </h1>
              <p className="text-gray-600 mb-6">{t("errorBoundary.text")}</p>
              <Link
                to="/"
                className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common.backToHome")}
              </Link>
            </div>
          )}
        </LanguageContext.Consumer>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
